<template>
	<div class="grid h-dvh w-full auto-rows-max justify-center">
		<header class="mt-32 mb-8 grid place-content-center">
			<img
				src="/assets/logos/studio_name_mark_gradient.svg"
				alt="Sales Studio logo"
				class="mt-4 w-[298px]"
			/>
		</header>
		<LoginForm
			class="flex w-screen max-w-[436px] min-w-[200px] flex-col justify-start"
		/>
	</div>
</template>

<script setup lang="ts">
import LoginForm from '@/components/forms/LoginForm.vue'
</script>
